import { useSelector } from "react-redux";
import { selectCurrent, selectSettings } from "../../../../redux/settings/selectors";
import { FormattedMessage } from 'react-intl';
import { useEffect, useState } from "react";
import { selectOrdersCreatedItem, selectOrdersCurrentItem } from "../../../../redux/orders/selector";
import { selectQuotesCreatedItem as selectCreateQuoteDetails } from "../../../../redux/quotes/selector";
import { useAppDispatch, useAppSelector } from "../../../../hooks/hooks";
import { selectUpdatedItem as selectInitiateRazorpayDetails } from "../../../../redux/razporpay/selector";
import { selectCmsSettingsListItems } from "../../../../redux/cmsSettings/selector";
import { selectListItems as selectLibraryListItems } from "../../../../redux/library/selector";
import GoogleMapSearch from "../../../../common/components/google-map-search";
import { getFormattedDate } from "../../../../common/services/date.service";
import moment from "moment";
import { RadioGroup } from "@headlessui/react";
import { settings } from "../../../../redux/settings/actions";
import _ from "lodash";
import { razorpay } from "../../../../redux/razporpay/action";
import { quotes } from "../../../../redux/quotes/action";
import storePersist from "../../../../redux/storePersist";
import { addPayment } from "../../../../redux/addPayment/action";
import { orders } from "../../../../redux/orders/action";
import { shippingTypes } from "../../../../redux/shippingTypes/action";
import { leads } from "../../../../redux/leads/action";
import { selectShippingTypesListItems } from "../../../../redux/shippingTypes/selector";
import { selectLeadsCreatedItem, selectLeadsListItems } from "../../../../redux/leads/selector";
import { useNavigate } from "react-router-dom";
import { selectCategoriesListItems } from "../../../../redux/categories/selector";
import { categories } from "../../../../redux/categories/action";
import { selectProductsListItems } from "../../../../redux/products/selector";
import { products } from "../../../../redux/products/action";
import { selectVariantsListItems } from "../../../../redux/variants/selector";
import { variants } from "../../../../redux/variants/action";
import { selectShippingProvidersListItems } from "../../../../redux/shipping-providers/selector";
import { shippingProviders } from "../../../../redux/shipping-providers/action";
import { selectOrganizationUnitsListItems } from "../../../../redux/organizationUnits/selector";
import useWindowDimensions from "../../../../hooks/useWindowsDimensions";
import { paymentMethods } from "../../../../redux/payment-methods/action";
import { selectPaymentMethodsQueryItems } from "../../../../redux/payment-methods/selector";
import { channel } from "../../../../redux/channel/action";
import queryString from "query-string";
import CryptoJS from 'crypto-js';
import { toast } from "react-toastify";
import { RotatingLines } from "react-loader-spinner";
import { InputContainer } from "../../../../common/components/form/form.module";
import { selectCustomersListItems, selectCustomersQueryItems } from "../../../../redux/customers/selector";
import { customers } from "../../../../redux/customers/action";
import ParcelBasicInfoComponent from "./parcel-basic-info";
import ParcelShipmentComponent from "./parcel-shipment";
import ParcelConfirmComponent from "./parcel-confirm";
import ParcelPaymentComponent from "./parcel-payment";
import ParcelLocationComponent from "./parcel-location";
import MediaInfoComponent from "../../../../common/components/common/media-info.component";
import { deepCopy } from "../../../../common/services/common.service";
import UploadFiles from "../../../../models/UploadFile";
declare let Razorpay: any;
let currentChange: any = {};
const ParcelBookingsWeb = () => {

	interface ISteps {
		CategoryName: string;
		ItemName: string
		PackageType: string
		Weight: string
		Width: string
		Height: string
		Length: string
		AdditionalInfo: string
		NumberOfItems: number
	}
	// interface IPackage {
	// 	package: string
	// }
	const { getUploadFiles } = useAppSelector(selectCurrent)
	const [isButtonLoading, setIsButtonLoading] = useState<boolean>(false)
	const [isLead, setIsLead] = useState<boolean>(false)
	const [isQuotes, setIsQuotes] = useState<boolean>(false)
	const dispatch = useAppDispatch();
	const result = useSelector(selectCurrent)
	const [color, setColor] = useState('universal')
	const defaultSetting = useSelector(selectSettings)
	const { header, footer, visible, sidebar, theme, primary, secondary } = defaultSetting
	const organizationUnitLists = useSelector(selectOrganizationUnitsListItems)
	const leadDetails = useSelector(selectLeadsListItems)
	const createLead = useSelector(selectLeadsCreatedItem)
	const quoteDetails = useSelector(selectCreateQuoteDetails)
	const paymentSettings = useSelector(selectCmsSettingsListItems)
	const libraryData = useSelector(selectLibraryListItems)
	const shippingTypesDetails = useSelector(selectShippingTypesListItems)
	const categoryListItems = useSelector(selectCategoriesListItems)
	const ProductLists = useSelector(selectProductsListItems)
	const variantLists = useSelector(selectVariantsListItems)
	const [isOrderTriggered, setIsOrderTriggered] = useState(false)
	const [isInitiateRazorpayTriggered, setIsInitiateRazorpayTriggered] = useState(false)
	const [isPaymentAdded, setIsPaymentAdded] = useState<any>(false);
	const [quoteData, SetQuoteData] = useState<any>({});
	const navigate = useNavigate()
	const [leadValues, setLeadValues] = useState<any>()
	const [productCount, setProductCount] = useState([1])
	const [generateIds, setGenerateIds] = useState<any>([]);
	const paymentMethodQuery = useSelector(selectPaymentMethodsQueryItems)
	const shippingProvidersListItems = useSelector(selectShippingProvidersListItems)
	const handleChange: any = (event: any, field: string) => {
		setLeadValues({ ...leadValues, [field]: event })
		SetQuoteData({ ...quoteData, [field]: event })
	}
	const [paymentGateway, setPaymentGateway] = useState<any>([]);
	const [razorpaySettings, setRazorpaySettings] = useState<any>([])
	const [isOrderPlaced, setIsOrderPlaced] = useState<any>(false);
	const { height, width } = useWindowDimensions();
	const orderDetails = useSelector(selectOrdersCreatedItem)
	const [orderId, setOrderId] = useState<any>()
	const [totalValue, setTotalValue] = useState(0);
	const customerListData = useSelector(selectCustomersListItems)
	var tenantId = storePersist.get('guestTokenMetadata')?.current?.result?.TokenMetadata?.TenantId
	const MODE = 'secure';
	const userProfileData = storePersist?.get("userProfile")?.current?.items[0]?.Message;

	var storeId = storePersist?.get("metaTokenMetaData")?.current?.items?.Localization?.StoreId;
	const [count, setCount] = useState(1)
	const [pickupLocations, setPickupLocation] = useState<any>({
		name: '',
		lat: '',
		lng: '',
		pincode: '',
		description: '',
	});
	const [dropLocations, setDropLocation] = useState<any>({
		name: '',
		lat: '',
		lng: '',
		pincode: '',
		description: '',
	});
	const [selectedInput, setSelectedInput] = useState("");
	const PackageType = [
		{ name: 'Standard Package' },
		{ name: 'Custom Package' }
	]
	const [productItems, setProductItems] = useState<any>([]);
	const [
		billImageIndex,
		setBillImageIndex
	] = useState<any>([])
	const [
		openFile,
		setOpenFile
	] = useState<any>([]);
	const [
		mediaFiles,
		setMediaFiles
	] = useState<any>([])

	const addNewItemsRow = ({ selectedItemsArg }: any) => {
		const localSelectediem = JSON.parse(JSON.stringify(selectedItemsArg))
		const newsSelectedItem = {
			Id: 0,
			CategoryId: 0,
			LogisticsProductId: 0,
			quantity: 0,
		};
		if (
			localSelectediem.length === 0 ||
			localSelectediem[localSelectediem?.length - 1]?.CategoryId !==
			0 ||
			localSelectediem[localSelectediem?.length - 1]?.LogisticsProductId !== 0 ||
			localSelectediem[localSelectediem?.length - 1]?.quantity !== 0
		) {
			localSelectediem?.push(newsSelectedItem);
		}

		return localSelectediem;
	};
	const handleFormItemChange: any = ({ value, field, idx }: any) => {
		const items = JSON.parse(JSON.stringify(productItems)) // deep copy of grn items
		let item = items[idx]; // deep copy of item to be edited
		item = { ...item, [field]: value }; // updated the particular item
		items[idx] = item;
		currentChange = { value, field, idx };
		setProductItems(items);
	};

	const setCombinationInfo = async () => {
		let localSelectedItem = JSON.parse(JSON.stringify(productItems));
		localSelectedItem.splice(currentChange.idx, 1, {
			...localSelectedItem[currentChange.idx],
		});
		localSelectedItem = addNewItemsRow({ selectedItemsArg: localSelectedItem });
		currentChange = productCount;

		setProductItems(localSelectedItem);
	};

	const items = [
		{
			name: 'Cash',
			description: 'Cash on delivery',
			value: 10,
			checked: '',
			show: paymentSettings?.result?.items?.MarketplaceSettings?.EnableForParcelCOD,
		},
		{
			name: 'Online',
			description: 'Payment gateway',
			value: 20,
			checked: 'checked',
			show: paymentSettings?.result?.items?.MarketplaceSettings?.EnableForParcelOnline,
		},
		{
			name: 'Wallet',
			description: 'Wallet',
			value: 40,
			checked: '',
			show: paymentSettings?.result?.items?.MarketplaceSettings?.EnableForWallet,
		},
	];

	const [selected, setSelected] = useState(items[0].value);

	const handleMinus = (index: any, data: any) => {
		handleFormItemChange({
			value: data - 1,
			idx: index,
			field: 'quantity'
		})
	}

	const handlePlus = (index: any, data: any) => {

		handleFormItemChange({
			value: data + 1,
			idx: index,
			field: 'quantity'
		})
	}

	const handlePackage = (e: any) => {

		setSelectedInput(e.target.value)
	}

	const generateUniqueId = () => {
		const randomPart = Math.random().toString(36).substr(2, 9); // Random part
		const timestampPart = Date.now().toString(36); // Timestamp part
		return `${randomPart}-${timestampPart}`;
	};

	const generateIdValue = () => {
		const newItem = {
			transaction_id: generateUniqueId(),
			message_id: generateUniqueId(),
			fulfillment_id: generateUniqueId(),
			item_id: generateUniqueId(),
			order_id: generateUniqueId(),
		};
		setGenerateIds(newItem);
	};

	const handleCustomerSearch = async ({ event }: any) => {
		await dispatch(customers.resetAction({ actionType: 'list' }))
		await dispatch(customers.list({
			url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/sales/crm/logistics-customers/list`, entity: 'categories', jsonData: {
				"Filters": [
					{
						"FieldName": "UserName",
						"FilterOperatorId": 6,
						"FieldValue": event,
						"FieldType": "text"
					}
				],
			}
		}))
	}

	let filterCustomer = _.find(customerListData.result.items, ['Id', leadValues?.CustomerId]);

	const handleAdd = () => {

		setProductCount([...productCount, 1])

		setCombinationInfo()
	}
	const handleDelete = (productItem: any, index: any) => {

		const updatedItems = [...productItems];  // Create a copy of the array
		updatedItems.splice(index, 1);  // Remove the item at the given index
		setProductItems(updatedItems)
	}

	// Media File Function 
	const changeImage = (idx: number, templateField: any, fileType: any) => {
		setBillImageIndex(idx)
		dispatch(settings.set({ getUploadFiles: 'open' }))
		setOpenFile({
			currentFileSrc: mediaFiles[idx][templateField],
			folder: 'shipping',
			type: fileType
		})
	}
	const handleMediaClose = () => {
		dispatch(settings.set({ getUploadFiles: 'close' }))

	}
	const handleFormMediaItemChange: any = ({ value, field, idx }: any) => {
		const items = deepCopy(mediaFiles);// deep copy of grn items
		let item = items[idx];// deep copy of item to be edited
		item = { ...item, [field]: value }// updated the particular item
		items[idx] = item;
		currentChange = { value, field, idx }
		setMediaFiles(items);
	}

	// Calculate total Product value
	useEffect(() => {
		const sum = productItems
			.filter(item => item.value) // Remove empty objects
			.reduce((sum, item) => sum + Number(item.value), 0);
		setTotalValue(sum);
	}, [productItems]);


	// Check condition
	const isOpenComponent = totalValue >= 50000;

	const addNewMediaFilesRow = ({ selectedMediaFilesArg }: any) => {
		const localSelectedmedia = deepCopy(selectedMediaFilesArg)
		const newsSelectedMedia = {
			Id: 0,
			FileTypeId: 0,
			OwnerId: 0,
			OwnerType: 'shipping',
			OwnerTypeId: 1007,
			FileMappingURL: ''
		}
		if (localSelectedmedia.length === 0 ||
			localSelectedmedia[localSelectedmedia?.length - 1]?.FileTypeId !== 0
		) {
			localSelectedmedia?.push(newsSelectedMedia)
		}

		return localSelectedmedia
	}
	const setMediaInfo = async () => {
		let localSelectedMedia = deepCopy(mediaFiles)
		localSelectedMedia.splice(
			currentChange.idx,
			1,
			{ ...localSelectedMedia[currentChange.idx] }
		);
		localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: localSelectedMedia });
		currentChange.field = 'FileTypeIdDONE'
		setMediaFiles(localSelectedMedia)
	}

	// useEffect(
	// 	() => {
	// 		if (currentChange.field === 'FileTypeId') {
	// 			setMediaInfo()
	// 		}
	// 	},
	// 	[mediaFiles]
	// )
	const handleSubmit = (data: any) => {

		mediaFiles[billImageIndex].FileMappingURL = data
		// const localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: mediaFiles });
		// setMediaFiles(localSelectedMedia)
	}
	const handleMediaData = () => {

		const invalidItem = mediaFiles.find(item => {
			return (
				!item?.FileMappingURL
			);
		});
		if (invalidItem) {
			toast.error("Please Upload The E-Way Bill.");
			return; // Stop execution if validation fails
		}
		handleNext();
	}
	const tutorialSteps = [
		{
			id: 1,
			title: 'Basic Details',
			subTitle: 'Basic Details',
			component: (



				<ParcelBasicInfoComponent
					setDropLocation={setDropLocation}
					setPickupLocation={setPickupLocation}
					filterCustomer={filterCustomer}
					handleCustomerSearch={handleCustomerSearch}
					customerListData={customerListData}
					dropLocations={dropLocations}
					pickupLocations={pickupLocations}
					leadValues={leadValues}
					handleChange={handleChange}
				/>




			),
			display: true,
		},
		{
			id: 2,
			title: 'Shipment Details',
			subTitle: 'Shipment Details',
			component: (


				<ParcelShipmentComponent
					handleDelete={handleDelete}
					handleAdd={handleAdd}
					handlePlus={handlePlus}
					handleMinus={handleMinus}
					variantLists={variantLists}
					ProductLists={ProductLists}
					categoryListItems={categoryListItems}
					handleFormItemChange={handleFormItemChange}
					handlePackage={handlePackage}
					selectedInput={selectedInput}
					PackageType={PackageType}
					productItems={productItems}
					libraryData={libraryData}
					shippingTypesDetails={shippingTypesDetails}
					quoteData={quoteData}
					handleChange={handleChange}
				/>




			),
			display: true,
		},
		{
			id: 3,
			title: 'Location Details',
			subTitle: 'Pickup Details',
			component: (

				<ParcelLocationComponent
					dropLocations={dropLocations}
					setDropLocation={setDropLocation}
					pickupLocations={pickupLocations}
					setPickupLocation={setPickupLocation}
					handleChange={handleChange}
					quoteData={quoteData}
					libraryData={libraryData}
				/>

			),
			display: true,
		},

		{
			id: 4,
			title: 'Confirm Booking',
			subTitle: 'Order Summary',
			component: (
				<ParcelConfirmComponent
					quoteDetails={quoteDetails}
					leadDetails={leadDetails}
				/>
			),
			display: true,
		},
		{
			id: 5,
			title: 'Upload the E-Way Bill',
			subTitle: 'E-Way',
			component: (
				<MediaInfoComponent
					changeImage={changeImage}
					// deleteSelectedProduct={deleteSelectedCategory}
					fileTypes={libraryData?.result?.FileType}
					//handleClose={handleClose}
					//handleOpen={handleOpen}
					onFormItemChange={handleFormMediaItemChange}
					// openConfirmation={openConfirmation}
					mediaFiles={mediaFiles}
				//uploadToDigiiFolder={uploadToDigiiFolder}
				/>
			),
			display: isOpenComponent,
		},
		{
			id: 6,
			title: 'Payment Option',
			subTitle: 'Select payment slot',
			component: (
				<ParcelPaymentComponent
					selected={selected}
					setSelected={setSelected}
					items={items}
				/>
			),
			display: true,
		},
	];

	const [activeStep, setActiveStep] = useState(0);
	const maxSteps = tutorialSteps.length;
	const handleNext = () => {
		setActiveStep((prevActiveStep) => prevActiveStep + 1);
	};

	const handleBack = () => {
		generateIdValue()
		setActiveStep((prevActiveStep) => prevActiveStep - 1);
	};


	useEffect(() => {

	}, [count, selectedInput]);
	useEffect(() => {

	}, [selected])

	useEffect(() => {
		setRazorpaySettings(paymentMethodQuery?.result?.items?.RazorPayConfiguration);

	}, [paymentMethodQuery]);

	useEffect(() => {
		const gateways: any = []
		if (razorpaySettings?.RazorPay?.IsActive) {
			gateways.push({ Id: 10, title: 'Razorpay', detail: 'Razorpay' })
		}
		if (razorpaySettings?.CCAvenue?.IsActive) {

			gateways.push({ Id: 20, title: 'CC Avenue', detail: 'CC Avenue' })
		}
		if (razorpaySettings?.PhonePe?.IsActive) {
			gateways.push({ Id: 30, title: 'PhonePe', detail: 'PhonePe' })
		}
		setPaymentGateway(gateways);
	}, [razorpaySettings]);


	// Step 1: Submit Lead
	const handleLeadSubmit = async (event: any) => {
		event?.preventDefault();

		// Validation for required fields
		if (
			// !leadValues?.Name ||
			// !leadValues?.PhoneNumber ||
			!leadValues?.date ||
			!pickupLocations?.description ||
			!dropLocations?.description
		) {
			toast.error("All fields are required. Please fill in all the details.");
			return; // Stop further execution if validation fails
		}

		// Parse addresses
		const fromAddressData = _.split(pickupLocations?.description, ',');
		const toAddressData = _.split(dropLocations?.description, ',');

		// Dispatch actions if validations pass
		try {
			await setIsButtonLoading(true)
			await dispatch(leads.resetAction({ actionType: 'create' }))
			await dispatch(
				leads.create({
					url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/logistics/transport/leads`,
					entity: "leads",
					jsonData: {
						Records: [
							{
								Context: {
									transaction_id: generateIds?.transaction_id,
									message_id: generateIds?.message_id,
								},
								Message: {
									LeadInfo: {
										Name: leadValues?.IsExistingUser ? filterCustomer?.AccountName : leadValues?.Name,
										Email: leadValues?.IsExistingUser ? filterCustomer?.Email : leadValues?.Email,
										PhoneNumber: leadValues?.IsExistingUser ? filterCustomer?.PhoneNumber : leadValues?.PhoneNumber,
										date: leadValues?.date,
										Description: leadValues?.Description,
										IsExistingUser: leadValues?.IsExistingUser,
										LeadPayload: {
											weight: {
												unit: "",
												value: leadValues?.weight || 0,
											},
											dimensions: {
												length: {
													unit: "",
													value: leadValues?.length || 0,
												},
												breadth: {
													unit: "",
													value: leadValues?.breadth || 0,
												},
												height: {
													unit: "",
													value: leadValues?.height || 0,
												},
											},
											category: "",
											value: {
												currency: "INR",
												value: 0,
											},
											dangerous_goods: false,
										},
										start: {
											location: {
												gps: `${pickupLocations?.lat},${pickupLocations?.lng}`,
												address: {
													name: pickupLocations?.name,
													building: pickupLocations?.description,
													locality: `${fromAddressData[0]},${fromAddressData[1]}`,
													city: pickupLocations?.name,
													state: fromAddressData[3],
													country: "India",
													area_code: pickupLocations?.pincode,
												},
											},
										},
										end: {
											location: {
												gps: `${dropLocations?.lat},${dropLocations?.lng}`,
												address: {
													name: dropLocations?.name,
													building: dropLocations?.description,
													locality: `${toAddressData[0]},${toAddressData[1]}`,
													city: dropLocations?.name,
													state: toAddressData[3],
													country: "India",
													area_code: dropLocations?.pincode,
												},
											},
										},
									},
								},
							},
						],
					},
				})
			)
			await setIsLead(true)
			await setIsButtonLoading(false)
		} catch (error) {
			toast.error("An error occurred while submitting the form. Please try again.");
		};
	};

	useEffect(() => {
		if (isLead && createLead?.isSuccess) {
			handleNext();
			setIsLead(false)
		}
	}, [isLead])

	const handleProductdata = () => {
		const invalidItem = productItems.find(item => {
			return (
				!item?.weight ||
				!item?.LogisticsProductId ||
				!item?.quantity ||
				!item?.CategoryId ||
				item?.LogisticsProductId === "--Select--" ||
				item?.CategoryId === "--Select--" ||
				item?.LogisticsVariantId === "--Select--" ||
				!item?.LogisticsVariantId ||
				!item?.value
			);
		});
		if (!quoteData?.category_id || quoteData?.category_id === "--Select--" || !quoteData?.code || quoteData?.code === "--Select--" || invalidItem) {
			toast.error("Please enter the required fields and ensure all details are filled in.");
			return; // Stop execution if validation fails
		}

		handleNext();
	}

	// Step 2: Submit Quotes
	const handleSaveQuote = async () => {
		// Validation for required fields
		const invalidItem = productItems.find(item => {
			return !item?.weight || !item?.LogisticsProductId || !item?.quantity || !item?.CategoryId || !item?.LogisticsVariantId; // Replace with your required conditions
		});
		if (
			!quoteData?.category_id ||
			!quoteData?.code ||
			invalidItem ||
			!pickupLocations?.description ||
			!dropLocations?.description
		) {
			toast.error("All fields are required. Please fill in all the details.");
			return; // Stop further execution if validation fails
		}

		let shippingType = _.find(shippingTypesDetails.result.items, ['ShippingTypeName', quoteData.category_id]);
		const fromAddressData = _.split(pickupLocations?.description, ',');
		const toAddressData = _.split(dropLocations?.description, ',');
		const selectedProducts = productItems?.map((item: any) => {
			const product = {
				CategoryId: item?.CategoryId,
				LogisticsProductId: item?.LogisticsProductId,
				LogisticsVariantId: item?.LogisticsVariantId,
				quantity: {
					count: item?.quantity,
					measure: {
						unit: "kg",
						value: item?.measure || 0
					}
				},
				weight: {
					unit: "mm",
					value: item?.weight || 0
				},
				dimensions: {
					length: {
						unit: "mm",
						value: item?.Length || 0
					},
					breadth: {
						unit: "mm",
						value: item?.breadth || 0
					},
					height: {
						unit: "mm",
						value: item?.Height || 0
					}
				},
				value: {
					currency: "INR",
					value: item?.value || 0
				},
				dangerous_goods: item?.dangerous_goods
			}

			return product;
		});
		const valueData = {
			order: {
				IsCargoOrder: false,
				provider: {
					id: shippingProvidersListItems?.result?.items[0]?.AccountPId,
					locations: []
				},
				items:
					[{
						id: String(shippingType.Id),
						fulfillment_id: generateIds?.fulfillment_id,
						category_id: quoteData?.category_id,
						descriptor: {
							code: quoteData?.code
						},
						time: {
							label: "",
							duration: "",
							timestamp: leadValues?.date || ""
						}
					}],
				billing: {},
				payment: {},
				LinkedItems: selectedProducts,
				fulfillments: [
					{
						id: generateIds?.fulfillment_id,
						type: quoteData?.type,
						start: {
							location: {
								gps: `${pickupLocations?.lat} ,${pickupLocations?.lng}`,
								address: {
									name: quoteData?.pickupName,
									building: quoteData?.startBuilding,
									locality: `${fromAddressData[0]},${fromAddressData[1]}`,
									city: pickupLocations?.name,
									state: fromAddressData[3] || 'TamilNadu',
									country: 'India',
									area_code: pickupLocations?.pincode || ''
								}
							},
							contact: {
								phone: quoteData?.pickupPhoneNumber,
								email: leadValues?.IsExistingUser ? filterCustomer?.Email : leadValues?.Email
							}
						},
						end: {
							location: {
								gps: `${dropLocations?.lat} ,${dropLocations?.lng}`,
								address: {
									name: quoteData?.dropName,
									building: quoteData?.endBuilding,
									locality: `${toAddressData[0]},${toAddressData[1]}`,
									city: dropLocations?.name,
									state: toAddressData[3] || 'TamilNadu',
									country: 'India',
									area_code: dropLocations?.pincode || ''
								}
							},
							contact: {
								phone: quoteData?.dropPhoneNumber,
								email: ''
							}
						}
					}
				]
			}
		}
		await setIsButtonLoading(true)
		await dispatch(quotes.resetAction({ actionType: 'create' }))
		await dispatch(quotes.create({
			url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/logistics/transport/logistics-quotes`, entity: 'quotes',
			jsonData: {
				Records: [{
					context: {
						transaction_id: createLead?.result?.Records[0]?.Context?.transaction_id,
						message_id: generateIds?.item_id,
					},
					message: valueData,
				}]
			}
		}))
		await setLeadValues({});
		await setIsQuotes(true)
		await setIsButtonLoading(false)


	}

	useEffect(() => {

		if (isQuotes && quoteDetails?.isSuccess) {
			setPickupLocation({
				name: '',
				lat: '',
				lng: '',
				pincode: '',
				description: ''
			})
			setDropLocation({
				name: '',
				lat: '',
				lng: '',
				pincode: '',
				description: ''
			})
			setIsQuotes(false)
			handleNext();
		}
	}, [isQuotes])


	// Step 3: Add Payment
	const handleOrder = async () => {
		await setIsButtonLoading(true)
		await dispatch(addPayment.update({
			url: `https://dom.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/dom/check-outs/add-payment`, entity: 'addPayment', jsonData: {
				Records: [{
					Context: {
						transaction_id: quoteDetails?.result?.Records[0]?.context?.transaction_id,
						message_id: generateIds?.message_id,
					},
					Message: {
						Id: quoteDetails?.result?.Records[0]?.message?.order?.Id,
						OwnerType: 'LogisticsOrder',
						PaidAmount: quoteDetails?.result?.Records[0]?.message?.order?.quote?.breakup[0]?.price?.value,
						PaymentRemarks: 'LogisticsOrder',
						PaymentMethodId: selected, // Number(sessionStorage.getItem('paymentmethod')),
						PaymentGatewayId: paymentGateway[0]?.Id || 0,
					},
				}

				],
			}
		})).then(() => {

			setIsPaymentAdded(true);
		})

	};

	// Step 4: Confirm Logistics Order
	useEffect(() => {
		if (isPaymentAdded) {
			const itemValues = quoteDetails?.result?.Records[0]?.message?.order?.items?.map((item: any) => {
				const data = {
					id: item?.id,
					fulfillment_id: item?.fulfillment_id,
					category_id: item?.category_id,
					descriptor: {
						code: item?.descriptor?.code
					},
					time: {
						label: null,
						duration: null,
						timestamp: item?.time?.timestamp
					}
				};
				return data;
			});

			const breakupValues = quoteDetails?.result?.Records[0]?.message?.order?.quote?.breakup?.map((item: any) => {
				const data = {
					"@ondc/org/item_id": item?.['@ondc/org/item_id'],
					"@ondc/org/title_type": item?.['@ondc/org/title_type'],
					"price": {
						"currency": item?.price?.currency,
						"value": item?.price?.value
					}
				};
				return data;
			});
			const fulfillmentValues = quoteDetails?.result?.Records[0]?.message?.order?.fulfillments?.map((item: any) => {
				const data = {
					"id": item?.id,
					"type": item?.type,
					"@ondc/org/awb_no": null,
					"start": {
						"person": {
							"name": item?.start?.contact?.email || ''
						},
						"location": {
							"gps": item?.start?.location?.gps,
							"address": {
								"name": item?.start?.location?.address?.name,
								"building": item?.start?.location?.address?.building,
								"locality": item?.start?.location?.address?.locality,
								"city": item?.start?.location?.address?.city,
								"state": item?.start?.location?.address?.state,
								"country": item?.start?.location?.address?.country,
								"area_code": item?.start?.location?.address?.area_code
							}
						},
						"contact": {
							"phone": item?.start?.contact?.phone,
							"email": item?.start?.contact?.email
						},
						"instructions": {
							"code": null,
							"short_desc": null,
							"long_desc": null,
							"additional_desc": {
								"content_type": null,
								"url": null
							},
							"images": null

						},
						"time": {
							"label": null,
							"duration": null,
							"timestamp": null
						}
					},
					"end": {
						"person": {
							"name": item?.end?.location?.address?.name || ''
						},
						"location": {
							"gps": item?.end?.location?.gps,
							"address": {
								"name": item?.end?.location?.address?.name,
								"building": item?.end?.location?.address?.building,
								"locality": item?.end?.location?.address?.locality,
								"city": item?.end?.location?.address?.city,
								"state": item?.end?.location?.address?.state,
								"country": item?.end?.location?.address?.country,
								"area_code": item?.end?.location?.address?.area_code
							}
						},
						"contact": {
							"phone": item?.end?.contact?.phone || '',
							"email": item?.end?.contact?.email || ''
						},
						"instructions": {
							"code": null,
							"short_desc": null,
							"long_desc": null,
							"additional_desc": {
								"content_type": null,
								"url": null
							},
							"images": null
						},
						"time": {
							"label": null,
							"duration": null,
							"timestamp": null
						}
					},
					"agent": {},
					"vehicle": {},
					"EWayBill": {
						"MediaFiles": isOpenComponent ? mediaFiles : [],
						"Templates": []
					},
					"@ondc/org/ewaybillno": null,
					"@ondc/org/ebnexpirydate": null,
					"tags": [
						{
							"code": null,
							"list": [
								{
									"code": null,
									"value": null
								}
							]
						}
					]
				};
				return data;
			});
			const linkedItemValues = quoteDetails?.result?.Records[0]?.message?.order?.LinkedItems?.map((item: any) => {
				let category = _.find(categoryListItems?.result?.items, ['Id', item?.CategoryId]);
				let product = _.find(ProductLists?.result?.items, ['Id', item?.LogisticsProductId]);
				const data = {
					"CategoryName": category?.Name,
					"CategoryId": item?.CategoryId,
					"LogisticsProductId": item?.LogisticsProductId,
					"LogisticsVariantId": item?.LogisticsVariantId,
					"descriptor": {
						"name": product?.Name
					},
					"quantity": {
						"count": item?.quantity?.count,
						"measure": {
							"unit": item?.quantity?.measure?.unit,
							"value": item?.quantity?.measure?.value
						}
					},

					"price": {
						"currency": item?.value?.currency,
						"value": item?.value?.value
					},
					"dangerous_goods": item?.dangerous_goods
				};
				return data;
			});
			const tagValues = quoteDetails?.result?.Records[0]?.message?.order?.tags?.map((item: any) => {
				const data = {
					code: item?.code,
					list: item?.list?.map((listItem: any) => {
						const data = {
							"code": listItem?.code,
							"value": listItem?.value
						}
						return data;

					})
				};
				return data;
			});
			const orderData = {
				context: {
					transaction_id: createLead?.result?.Records[0]?.Context?.transaction_id,
					message_id: generateIds?.fulfillment_id,
				},
				message: {
					order: {
						created_at: moment.utc(),
						updated_at: moment.utc(),
						id: generateIds.order_id,
						state: null,
						IsCargoOrder: false,
						provider: {
							id: quoteDetails?.result?.Records[0]?.message?.order?.provider?.id,
							locations: quoteDetails?.result?.Records[0]?.message?.order?.provider?.locations
						},
						items: itemValues,
						quote: {
							price: {
								currency: quoteDetails?.result?.Records[0]?.message?.order?.quote?.price?.currency,
								value: quoteDetails?.result?.Records[0]?.message?.order?.quote?.price?.value,
							},
							breakup: breakupValues
						},
						fulfillments: fulfillmentValues,
						"billing": {
							"name": fulfillmentValues[0]?.start?.person?.name || '',
							"address": {
								"name": fulfillmentValues[0]?.start?.location?.address?.name || '',
								"building": fulfillmentValues[0]?.start?.location?.address?.building || '',
								"locality": fulfillmentValues[0]?.start?.location?.address?.locality || '',
								"city": fulfillmentValues[0]?.start?.location?.address?.city || '',
								"state": fulfillmentValues[0]?.start?.location?.address?.state || '',
								"country": fulfillmentValues[0]?.start?.location?.address?.country || '',
								"area_code": fulfillmentValues[0]?.start?.location?.address?.area_code || '',
							},
							"tax_number": "",
							"phone": fulfillmentValues[0]?.start?.contact?.phone,
							"email": fulfillmentValues[0]?.start?.contact?.email,

						},
						"payment": {
							"@ondc/org/collection_amount": null,
							"collected_by": null,
							"type": null,
							"@ondc/org/settlement_details": [
								{
									"settlement_counterparty": null,
									"settlement_type": null,
									"upi_address": null,
									"settlement_bank_account_no": null,
									"settlement_ifsc_code": null
								}
							]
						},
						"@ondc/org/linked_order": {
							"items": linkedItemValues,
							"provider": {
								"descriptor": {
									"name": null
								},
								"address": {
									"name": organizationUnitLists?.result?.items[0]?.Name,
									"building": organizationUnitLists?.result?.items[0]?.PrimaryAddress?.Address1,
									"locality": organizationUnitLists?.result?.items[0]?.PrimaryAddress?.Address2,
									"city": organizationUnitLists?.result?.items[0]?.PrimaryAddress?.City,
									"state": organizationUnitLists?.result?.items[0]?.PrimaryAddress?.StateProvince?.Name,
									"country": organizationUnitLists?.result?.items[0]?.PrimaryAddress?.Country?.Name,
									"area_code": organizationUnitLists?.result?.items[0]?.PrimaryAddress?.ZipPostalCode
								}
							},
							"order":
							{
								"id": null,
								"weight": {
									"unit": "mm",
									"value": 600
								},
								"dimensions": {
									"length": {
										"unit": "mm",
										"value": 50
									},
									"breadth": {
										"unit": "mm",
										"value": 60
									},
									"height": {
										"unit": "mm",
										"value": 30
									}
								}
							}

						},
						"tags": tagValues,

					}
				}
			}
			dispatch(orders.create({
				url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/logistics/transport/shipments/confirm-logistics-order`,
				entity: 'orderCreate',
				jsonData: {
					Records: [orderData]
				}
			})).then(() => {
				setIsButtonLoading(false)
				setIsOrderPlaced(true);
			})
		}
	}, [isPaymentAdded])

	// Start- ccAvenue function
	const encrypt1 = (plainText: string, workingKey: string): string => {
		// Create an MD5 hash of the workingKey
		const key = CryptoJS.MD5(workingKey).toString(CryptoJS.enc.Hex);

		// Initialization vector (IV)
		const iv = CryptoJS.enc.Hex.parse('000102030405060708090a0b0c0d0e0f');

		// Encrypt the plainText
		const encrypted = CryptoJS.AES.encrypt(plainText, CryptoJS.enc.Hex.parse(key), {
			iv: iv,
			mode: CryptoJS.mode.CBC,
			padding: CryptoJS.pad.Pkcs7,
		});

		// Return the encrypted text in hex format
		return encrypted.ciphertext.toString(CryptoJS.enc.Hex);
	};

	const handeCCAvenuePayment = (orderDetails: any) => {
		const workingKey =
			razorpaySettings.CCAvenue?.WorkingKey; //Put in the 32-Bit key shared by CCAvenues.
		const accessCode =
			razorpaySettings.CCAvenue?.AccessCode;
		const merchantId =
			razorpaySettings.CCAvenue?.MerchantId;

		const companyName = localStorage.getItem("CompanyName");
		const channelId = storePersist.get("accessTokenMetadata").current?.TokenMetadata?.SalesChannelId;
		const tenant = companyName; //getBusinessCompanyName();

		// const guestTokenData = {
		// 	Channel: channel.SalesChannelName, //SalesChannelName(),
		// 	Requester: `https://${tenant}.csp.digiit.${process.env.REACT_APP_API_URL}/`,
		// 	StoreId: storeId,
		// 	SalesChannelId: ChannelId,
		// };
		// const accessTokenData = {
		// 	PhoneNumber: userInfo[0]?.PhoneNumber,
		// 	TenantName: tenant,
		// 	SalesChannelId: ChannelId,
		// };
		const ccAvenueData = {
			merchant_id: merchantId,
			order_id: orderDetails?.order?.id,
			currency: 'INR',
			amount: Number(orderDetails?.order?.quote?.price?.value), //Total Price,
			//   ENABLE WHILE TESTING LOCALLY. NEEDS TO BE RUN ALONG WITH PAYMENTS REPO.
			//   redirect_url: `http://localhost:3004/${MODE}/${tenant}/${tenantId}/${storeId}/${channelId}/${billingAddress?.PhoneNumber}/ccavResponseHandler`,
			//   cancel_url: `http://localhost:3004/${MODE}/${tenant}/${tenantId}/${storeId}/${channelId}/${billingAddress?.PhoneNumber}/ccavResponseHandler`,

			// ENABLE FOR PRODUCTION
			redirect_url: `https://payments.digiit.${process.env.REACT_APP_API_URL}/${MODE}/${tenant}/${tenantId}/${storeId}/${channelId}/${userProfileData?.PhoneNumber}/ccavResponseHandler`,
			cancel_url: `https://payments.digiit.${process.env.REACT_APP_API_URL}/${MODE}/${tenant}/${tenantId}/${storeId}/${channelId}/${userProfileData?.PhoneNumber}/ccavResponseHandler`,
			language: 'EN',
			billing_name: orderDetails?.order?.billing?.name,
			billing_address: orderDetails?.order?.billing?.address?.name,
			billing_city: orderDetails?.order?.billing?.address?.city,
			billing_state: orderDetails?.order?.billing?.address?.state,
			billing_zip: orderDetails?.order?.billing?.address?.area_code,
			billing_country: orderDetails?.order?.billing?.address?.country,
			billing_tel: userProfileData?.PhoneNumber,
			billing_email: userProfileData?.Email,
			delivery_name: orderDetails?.order?.fulfillments[0]?.end?.person?.name,
			delivery_address: orderDetails?.order?.fulfillments[0]?.end?.location?.address?.name,
			delivery_city: orderDetails?.order?.fulfillments[0]?.end?.location?.address?.city,
			delivery_state: orderDetails?.order?.fulfillments[0]?.end?.location?.address?.state,
			delivery_zip: orderDetails?.order?.fulfillments[0]?.end?.location?.address?.area_code,
			delivery_country: orderDetails?.order?.fulfillments[0]?.end?.location?.address?.country,
			merchant_param1: tenant, //getOrganizationName(),
			merchant_param2: tenantId,
			merchant_param3: `${window.location.hostname}`,
			merchant_param4: "transport-agent/order-details",
			merchant_param5: '',
			integration_type: 'iframe_normal',
			// promo_code:'PROMO8513',
			customer_identifier: userProfileData?.Email,
		};
		const body = queryString.stringify(ccAvenueData);

		const encRequest1 = encrypt1(body, workingKey);
		// let URL = `https://test.ccavenue.com/transaction/transaction.do?command=initiateTransaction&merchant_id=${ccAvenueData.merchant_id}6&encRequest=${encRequest1}&access_code=${accessCode}`;
		let URL = `https://secure.ccavenue.com/transaction/transaction.do?command=initiateTransaction&merchant_id=${ccAvenueData.merchant_id}6&encRequest=${encRequest1}&access_code=${accessCode}`;

		window.location.href = URL;
		// router.push(URL);
	}
	// End - ccAvenue function
	useEffect(() => {
		if (isOrderPlaced) {
			switch (selected) {
				case 10: //cash payment
					navigate(`/transport-agent/order-details`)
					break;
				case 20: //online
					switch (paymentGateway[0]?.Id) {
						case 10: //razorpay
							// handeRazorpay()
							break;
						case 20: //ccavenue
							handeCCAvenuePayment(orderDetails?.result?.items?.Records[0]?.message)
							break;
						case 30: //phonepe
							break;
						default:
					}


					break;
				case 30: //wallet
					break;
			}

		}
	}, [isOrderPlaced])

	useEffect(
		() => {
			window.scrollTo({ top: 0, behavior: "smooth" })
			const localSelectedItems = addNewItemsRow({
				selectedItemsArg: productItems,
			});
			const localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: mediaFiles });
			setMediaFiles(localSelectedMedia)
			setProductItems(localSelectedItems);
			generateIdValue()
			dispatch(shippingTypes.list({ url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/transport/shipping-types/list`, entity: 'shippingTypes', jsonData: {} }))
				.then(() => {
					dispatch(shippingProviders.list({
						url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/shipment-management/shipping-providers/list`, entity: 'shippingProviders', jsonData: {
						}
					}))
				}).then(() => {
					dispatch(products.list({ url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/products/list`, entity: 'products', jsonData: {} }))
				}).then(() => {
					dispatch(variants.list({
						url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/variants/list`, entity: 'variants', jsonData: {}
					}))
				})
				.then(() => {
					dispatch(categories.list({
						url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/categories/list`,
						entity: 'categories',
						jsonData: {}
					}));
				}).then(() => {
					dispatch(paymentMethods.query({
						url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v2.0/configuration/payment-management/payment-methods/query-by-tenants`, entity: 'paymentMethods', jsonData:
							{ "Tenants": [{ "Id": tenantId }] }
					}))
				}).then(() => {
					dispatch(channel.list({ url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/configuration/organization-management/channels/list`, entity: 'channels', jsonData: {} }))
				})
		},
		[]
	);
	const handleClose = async () => {
		generateIdValue()
		await dispatch(leads.resetAction({ actionType: 'create' }))
		await dispatch(quotes.resetAction({ actionType: 'create' }))
		await setPickupLocation({
			name: '',
			lat: '',
			long: '',
			pincode: '',
			description: ''
		})
		await setDropLocation({
			name: '',
			lat: '',
			long: '',
			pincode: '',
			description: ''
		})
		const localSelectedItems = addNewItemsRow({
			selectedItemsArg: [],
		});
		await setProductItems(localSelectedItems);
		await SetQuoteData({})
		await setActiveStep(0)
	}
	useEffect(() => {

		if (!isOpenComponent && tutorialSteps[activeStep]?.display === false && tutorialSteps[activeStep].subTitle === 'E-Way') {

			handleNext();
		}
	}, [tutorialSteps])
	return (
		<>
			{getUploadFiles == 'open' && <UploadFiles currentFilesSrc={openFile?.currentFileSrc}
				folder={openFile?.folder}
				handleClose={handleMediaClose}
				handleFilesSubmit={handleSubmit}
				type={openFile?.type}
				ownerId={0}
			/>}
			<div className="flex flex-col items-center w-auto px-5 overflow-auto h-auto">
				<>
					{width && width < 720 ? <div className="flex justify-center items-center pt-2 px-2 sm:px-0">
						<div className="my-2 mx-auto max-w-sm w-full sm:w-auto">
							<div className={`rounded-lg shadow-lg flex flex-col w-full bg-secondary p-5 overflow-auto`}>
								<div className="flex items-start justify-between w-full border-b p-2">
									<div className="flex w-full flex-col items-center justify-between text-xl">
										{tutorialSteps[activeStep].title}
									</div>
								</div>
								<div className="w-full flex flex-col sm:flex-row p-2 border-b py-5">
									<div className="flex flex-col w-full sm:w-3/4 space-y-3">
										{tutorialSteps[activeStep].component}
									</div>
								</div>

								<div className="w-full flex flex-col sm:flex-row p-3">
									<div className="w-full sm:w-1/4">
										{/* Placeholder for spacing */}
									</div>
									{tutorialSteps[activeStep].id === maxSteps ? (
										<div className="w-full sm:w-3/4">
											<div className="flex flex-row justify-end items-center space-x-2">
												<button onClick={handleClose} className={`bg-blue-700 text-white  border-x border-y  px-2 py-1 text-sm font-bold`}>
													Book Later
												</button>
												<button onClick={handleOrder} className={`bg-blue-700 text-white  border-x border-y  px-2 py-1 text-sm font-bold`}>
													Confirm Booking
												</button>
											</div>
										</div>
									) : (
										<>
											<div className="w-full ">
												<div className="flex flex-row justify-end items-center space-x-2">
													{activeStep !== 0 && activeStep !== 3 && (<button onClick={handleBack} className={`bg-blue-700 text-white  border-x border-y  px-2 py-1 text-sm font-bold`}>
														Back										</button>)}
													{tutorialSteps[activeStep].id === 1 && (<button onClick={handleLeadSubmit} disabled={isButtonLoading && activeStep === maxSteps - 1} className={`${isButtonLoading ? 'bg-blue-700 bg-opacity-70 w-20 ' : 'bg-blue-700 '}  text-white items-center justify-center flex flex-row   border-x border-y  px-2 py-1 text-sm font-bold `}>
														Next
														{isButtonLoading && <div className={`${isButtonLoading ? 'visible' : 'invisible'}`}>
															<RotatingLines
																visible={true}
																width={'20'}
																strokeColor="#fff"
																strokeWidth="6"
																animationDuration="0.75"
																ariaLabel="rotating-lines-loading"
															/>
														</div>}

													</button>)}
													{tutorialSteps[activeStep].id !== 1 && tutorialSteps[activeStep].id !== 3 && (<button onClick={handleNext} disabled={activeStep === maxSteps - 1} className={`bg-blue-700 text-white border-x border-y  px-2 py-1 text-sm font-bold`}>
														Next
													</button>)}
													{tutorialSteps[activeStep].id === 3 && (<button onClick={handleSaveQuote} disabled={isButtonLoading && activeStep === maxSteps - 1} className={`${isButtonLoading ? 'bg-blue-700 bg-opacity-70 w-20 ' : 'bg-blue-700 '}  text-white items-center justify-center flex flex-row   border-x border-y  px-2 py-1 text-sm font-bold `}>
														Next
														{isButtonLoading && <div className={`${isButtonLoading ? 'visible' : 'invisible'}`}>
															<RotatingLines
																visible={true}
																width={'20'}
																strokeColor="#fff"
																strokeWidth="6"
																animationDuration="0.75"
																ariaLabel="rotating-lines-loading"
															/>
														</div>}
													</button>)}

												</div>
											</div>
										</>
									)}
								</div>
							</div>
						</div>
					</div> :
						<div className="flex justify-center items-center w-full bg-white">
							<div className=" my-2 mx-auto w-full">
								<div className={` rounded-lg shadow-lg flex flex-col w-full p-5`}>
									<div className="flex items-start justify-between w-full border-b p-2 ">
										<div className="flex w-full flex-col items-center justify-between text-xl" >
											{tutorialSteps[activeStep]?.title}
										</div>
									</div>
									<div className="w-full flex flex-row justify-center items-center border-b p-2 py-5">
										<div className="flex flex-col w-3/4 space-y-3">
											{tutorialSteps[activeStep]?.component}
										</div>
									</div>

									<div className="w-full flex flex-row p-3 ">

										{tutorialSteps[activeStep]?.id === maxSteps ? (
											<div className="w-full">
												<div className="flex flex-row justify-end items-center space-x-2">
													<button onClick={handleClose} className={`bg-primary text-light border-x border-y  px-2 py-1 text-sm font-bold rounded-md`}>
														Book Later
													</button>
													<button onClick={handleOrder} disabled={isButtonLoading} className={`${isButtonLoading ? 'bg-primary bg-opacity-70 w-44 ' : 'bg-primary'}  text-light items-center justify-center flex flex-row   border-x border-y  px-2 py-1 text-sm font-bold rounded-md`}>
														Confirm Booking
														{isButtonLoading && <div className={`${isButtonLoading ? 'visible' : 'invisible'}`}>
															<RotatingLines
																visible={true}
																width={'20'}
																strokeColor="#fff"
																strokeWidth="6"
																animationDuration="0.75"
																ariaLabel="rotating-lines-loading"
															/>
														</div>}
													</button>
												</div>
											</div>) : (
											<>
												<div className="w-full">

													<div className="flex flex-row justify-end items-center space-x-2">
														{activeStep !== 0 && activeStep !== 3 && (<button onClick={handleBack} className={`bg-primary text-light border-x border-y  px-2 py-1 text-sm font-bold rounded-md`}>
															Back										</button>)}
														{tutorialSteps[activeStep].id === 1 && (<button onClick={handleLeadSubmit} disabled={isButtonLoading && activeStep === maxSteps - 1} className={`${isButtonLoading ? 'bg-primary bg-opacity-70 w-20 ' : 'bg-primary'} text-light items-center justify-center flex flex-row   border-x border-y  px-2 py-1 text-sm font-bold rounded-md`}>
															Next
															{isButtonLoading && <div className={`${isButtonLoading ? 'visible' : 'invisible'}`}>
																<RotatingLines
																	visible={true}
																	width={'20'}
																	strokeColor="#fff"
																	strokeWidth="6"
																	animationDuration="0.75"
																	ariaLabel="rotating-lines-loading"
																/>
															</div>}

														</button>)}
														{tutorialSteps[activeStep].id !== 1 && tutorialSteps[activeStep].id !== 2 && tutorialSteps[activeStep].id !== 3 && tutorialSteps[activeStep].id !== 5 && (<button onClick={handleNext} disabled={activeStep === maxSteps - 1} className={`bg-primary text-light border-x border-y  px-2 py-1 text-sm font-bold rounded-md`}>
															Next
														</button>)}
														{tutorialSteps[activeStep].id === 2 && (<button onClick={handleProductdata} className={`bg-primary text-light border-x border-y  px-2 py-1 text-sm font-bold rounded-md`}>
															Next
														</button>)}
														{tutorialSteps[activeStep].id === 5 && (<button onClick={handleMediaData} className={`bg-primary text-light border-x border-y  px-2 py-1 text-sm font-bold rounded-md`}>
															Next
														</button>)}
														{tutorialSteps[activeStep].id === 3 && (<button onClick={handleSaveQuote} disabled={isButtonLoading && activeStep === maxSteps - 1} className={`${isButtonLoading ? 'bg-primary bg-opacity-70 w-20 ' : 'bg-primary'}  text-light items-center justify-center flex flex-row   border-x border-y  px-2 py-1 text-sm font-bold rounded-md`}>
															Next
															{isButtonLoading && <div className={`${isButtonLoading ? 'visible' : 'invisible'}`}>
																<RotatingLines
																	visible={true}
																	width={'20'}
																	strokeColor="#fff"
																	strokeWidth="6"
																	animationDuration="0.75"
																	ariaLabel="rotating-lines-loading"
																/>
															</div>}
														</button>)}

													</div>
												</div>
											</>
										)}

									</div>
								</div>
							</div>
						</div>

					}
				</>
			</div>
		</>
	);
};

export default ParcelBookingsWeb;


